import "./scss/index.scss";
import { Link } from "@reach/router";
import * as React from "react";
import DynamicListBase from "../../components/DynamicListBase";
import { generateBlogCategoryUrl } from "../../core/paths";
import { PageCategory } from "../../core/types";
import { CategoryArticleList } from "../../components";
import { Box, Container, Divider, Flex, Grid, HStack, Tag, TagLabel, VStack } from "@chakra-ui/react";
import { MainCategoryTile, MAIN_CATEGORY_TILE_TYPE } from "../BlogCategory/components/MainCategoryTile";
import { ChildrenChips } from "../BlogCategory/components/ChildrenChips";
import { PrimaryPostTile } from "../BlogCategory/components/PrimaryPostTile";
import { SecondaryPostTile } from "../BlogCategory/components/SecondaryPostTile";
import { WidgetTitle } from "@components/Texts/WidgetTitle/WidgetTitle";
import { Tile, TILE_MODES } from "@components/Tiles/Tile";
import { RTag } from "@components/Texts/Tag/Tag";
import { CommonTags } from "src/containers/CommonTags/CommonTags";

interface IProps {
  currentCategory: PageCategory;
  mainCategory: PageCategory;
  categories: PageCategory[];
  suggestedPosts: any[];
  tags: any[];
}

export class Page extends DynamicListBase<IProps> {
  render() {
    const { mainCategory, currentCategory, tags = [], pageTags = [], categories = [], suggestedPosts = [] } = this.props;
    const { hasNextPage, hasPrevPage } = this.state;
    const [firstPost, ...restPosts] = this.getPageData();

    return (
      <Container maxW="1130px" px="15px" mt={{ base: "0", sm: "47px" }}>
        <MainCategoryTile category={mainCategory} type={MAIN_CATEGORY_TILE_TYPE.TAG} />
        <PrimaryPostTile post={firstPost} mb="50px" />
        <Divider bg="#DDECFB" h="2px" mb="35px" />

        <HStack spacing="30px" mb={{base: "25px", md: '100px'}} flexWrap={{base: 'wrap', md: "nowrap"}} alignItems="flex-start">
          <Box w="100%" maxW="830px" flexGrow={1 as any}>
            <VStack d={{base: 'none', md: 'block'}} spacing="45px">
              {restPosts.map(post => (
                <SecondaryPostTile key={post.id} post={post} />
              ))}
            </VStack>
            <VStack d={{base: 'block', md: 'none'}} spacing="45px">
              {restPosts.map(post => (
                <Tile key={post.id} d={{base: 'block', sm: 'none'}} mode={TILE_MODES.SHORT_MOBILE_THUMBNAIL_RIGHT} article={post} />
              ))}
            </VStack>
          </Box>
          <Box d={{base: 'none', md: 'block'}} maxW="260px" w="100%">
            <CommonTags tags={pageTags} />
          </Box>
        </HStack>
        <Box d={{base: 'block', md: 'none'}} mb="70px" maxW="260px" w="100%">
          <CommonTags tags={pageTags} />
        </Box>
        {/* <VStack background="#EAF4FF" alignItems="flex-start" spacing="32px" px="77px" mx="-77px" py="49px">
          <WidgetTitle color="#222C63">ZOBACZ RÓWNIEŻ</WidgetTitle>
          <Grid templateColumns="repeat(4, 1fr)" gap="32px">
            {suggestedPosts.map(post => (<Tile mode={TILE_MODES.SHORT_WITH_THUMBNAIL} article={post} />))}
          </Grid>
        </VStack> */}
      </Container>
    );
    return (
      <div className="container blog-category">
        <div className="blog-category__name">
          {currentCategory.name}
          {/* <ArticleNumber
            articleNumber={currentCategory.articleNumber}
            customClass="blog-category__article-number"
          /> */}

          <div className="hidden md:flex flex-wrap space-y-3 items-end mb-12">
            {categories.map(({ name, id, slug }) => (
              <Link
                to={generateBlogCategoryUrl(slug)}
                key={id}
                className={`${
                  currentCategory?.id === id
                    ? "bg-pink-1 text-white"
                    : "bg-grey-16"
                } transition-all duration-300 rounded-xl text-s font-semibold cursor-pointer h-10 mr-3 leading-10 px-10 cursor-pointer`}
              >
                {name}
              </Link>
            ))}
          </div>
        </div>
        <div className="dynamic-list">
          {hasPrevPage && (
            <button
              onClick={this.prevPage}
              className="blog-category__show-previous button"
            >
              Zobacz poprzednie
            </button>
          )}
          <CategoryArticleList posts={posts} />
          {hasNextPage && (
            <button onClick={this.nextPage} className="button">
              Zobacz następne
            </button>
          )}
        </div>
      </div>
    );
  }
}

export default Page;
